import React from 'react';
import { CaseTimelineTabMain } from "../storyboard/CaseTimeline";

const StoryboardMain = (props) => {
    return (
        <CaseTimelineTabMain {...props} />
    );
};

export default StoryboardMain;